import CountryLanguageWriteDTO from '../country-language/CountryLanguageWriteDTO';

export default class CountryWriteDTO {

    public id: string | undefined;
    public name: string | undefined;
    public depMarketName: string | undefined;
    public languages: CountryLanguageWriteDTO[] = [];

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.depMarketName = data['depMarketName'] || undefined;
        if (data['languages']) {
            this.languages = data['languages'].map((item: any) => new CountryLanguageWriteDTO(item));
        }
    }
}
